import {SET_MESSAGES_BY_LANGUAGE} from "./preferences";


export default function setImportantMessages(state){

  return {
      type: SET_MESSAGES_BY_LANGUAGE,
      payload: {
        state
     }
}
}
